//
// Copyright (c) 2011-2017 by Curalate, Inc.
//
var _ = require("underscore").default;

/* eslint-disable */
let mapOption;
let filterObject;
let compactObject;
let objectValuesContains;
let safeGet;
let grouped;
let sum;

// In Scala: Some(1).map(_ + 1) == Some(2)
// In JS:    _(1).mapOption(function(num) { return num + 1 }); == 2
//
// In Scala: None.map(_ + 1) == None
// In JS:    _(undefined).mapOption(function(num) { return num + 1}) == undefined
mapOption = function(val, func) {
    return _.chain([val]).compact().map(func).first().value();
};

// Filter an object based on a predicate. Differs from .filter on an Object in that
// this function actually returns an Object, rather than an arrya
filterObject = function(object, filterFunc) {
    return _.chain(object).
        pairs().
        filter(function(pair) { return filterFunc(pair[1], pair[0]); }).
        object().
        value();
};

// Removes all defined properties in an object which point to "undefined"
compactObject = function(object) {
    return _.filterObject(object, function(val) { return !_.isUndefined(val) && !_.isNaN(val); });
};

objectValuesContains = function(object, value, transform) {
    transform = transform || _.identity;

    return _.chain(object).values().map(transform).contains(value).value();
};

safeGet = function(obj, key) {
    var idx = key.indexOf('.'),
        head, tail;

    if (_.isUndefined(obj)) {
        return undefined;
    }

    if (_.isNull(obj)) {
        return undefined;
    }

    if (key.length === 0) {
        return obj;
    }

    if (idx < 0) {
        return obj[key];
    }

    head = key.substring(0, idx);
    tail = key.substring(idx + 1);

    if (_.isArray(obj) && _.isNumber(parseInt(head, 10))) {
        return _(obj[parseInt(head, 10)]).safeGet(tail);
    } else if (obj[head]) {
        return _(obj[head]).safeGet(tail);
    } else {
        return undefined;
    }
};

grouped = function(object, n) {
    return _(object).chain().groupBy(function(_, idx) {
        return Math.floor(idx / n);
    }).values().value();
};

sum = function(object) {
    return _(object).reduce(function(memo, o) {
        return memo + o;
    }, 0);
};

var flatMap = function(object, func) {
    return _(object).chain().map(func).flatten().value();
};

_.mixin({
    mapOption: mapOption,
    filterObject: filterObject,
    compactObject: compactObject,
    objectValuesContains: objectValuesContains,
    safeGet: safeGet,
    grouped: grouped,
    sum: sum,
    flatMap: flatMap
});

module.exports = _.default;
